// Outfits e montarias do personagem: quais ele tem, validação da escolha e pontos para o ranking.
import { MOUNT_LIST, OUTFIT_LIST, type OutfitDef } from './outfit-list.js';

/** Outfits custom do Baiak (não existem no Global). Recompensas exclusivas, como a do passe de batalha. */
export const CUSTOM_OUTFITS: Array<OutfitDef & { desc: string }> = [
  { name: 'Ceifador da Abóbora', male: 9001, female: 9001, free: false, desc: 'Exclusivo do passe de batalha de outubro de 2026 (Halloween). Nunca mais será obtido.' },
];
export const ALL_OUTFITS: OutfitDef[] = [...OUTFIT_LIST, ...CUSTOM_OUTFITS];

export interface Cosmetics {
  auras?: string[]; aura?: string;
  /** outfits ganhos (nome → addons: bit 1 = primeiro, bit 2 = segundo) */
  outfits?: Record<string, number>;
  mounts?: number[]; mount?: number | null;
}

export function outfitByLook(look: number): OutfitDef | undefined {
  return ALL_OUTFITS.find((o) => o.male === look || o.female === look);
}
/** Addons que o personagem tem nesse outfit (null = não tem o outfit). */
export function ownedAddons(c: Cosmetics | undefined, o: OutfitDef): number | null {
  const got = c?.outfits?.[o.name];
  if (got !== undefined) return got & 3;
  return o.free ? 0 : null;
}
export function ownedOutfits(c: Cosmetics | undefined): Array<{ def: OutfitDef; addons: number }> {
  return ALL_OUTFITS.map((def) => ({ def, addons: ownedAddons(c, def) })).filter((x): x is { def: OutfitDef; addons: number } => x.addons !== null);
}
export function mountById(id: number | null | undefined) { return id ? MOUNT_LIST.find((m) => m.id === id) : undefined; }

/** Pontos do ranking de outfits: outfit = 1, com 1 addon = 2, completo = 3 (decisão do Arthur). */
export function outfitPoints(c: Cosmetics | undefined): number {
  return ownedOutfits(c).reduce((t, o) => t + 1 + ((o.addons & 1) ? 1 : 0) + ((o.addons & 2) ? 1 : 0), 0);
}
export function mountPoints(c: Cosmetics | undefined): number { return (c?.mounts ?? []).length; }
